import { API_SUCCESS, API_FAILED, apiAction } from '../core/apiCoreRedux';
const FETCH_COMPANY_DETAILS = 'FETCH_COMPANY_DETAILS';
const SET_COMPANY_DETAILS = 'SET_COMPANY_DETAILS';
const initialState = [];
const initialAction = {
  type: '',
  payload: []
};

// actions
export const fetchCompanyDetails = (successCallback = () => { }, failureCallback = () => { }) => {
  return (
    {
      type: FETCH_COMPANY_DETAILS,
      payload: {
        successCallback,
        failureCallback
      }
    }
  )

};

export const setCompanyDetails = (data) => ({
  type: SET_COMPANY_DETAILS,
  payload: data
});

// Middleware
export const fetchCompanyDetailsMidlleware =
  ({ dispatch }) =>
    (next) =>
      (action) => {
        next(action);
        switch (action.type) {
          case FETCH_COMPANY_DETAILS:
            const { successCallback, failureCallback } = action.payload;
            dispatch(
              apiAction({
                url: `:8989/admin/company`,
                actionType: FETCH_COMPANY_DETAILS,
                meta: { successCallback, failureCallback }
              })
            );
            break;

          case `${FETCH_COMPANY_DETAILS} ${API_SUCCESS}`:
            next(setCompanyDetails(action.payload.companies));
            action.meta.successCallback();
            break;

          case `${FETCH_COMPANY_DETAILS} ${API_FAILED}`:
            action.meta.failureCallback();

          default:
          // nothing to be done
        }
      };

// Reducers
export const companyDetailsReducer = (state = initialState, action = initialAction) => {
  if (action.type === SET_COMPANY_DETAILS) {
    return action.payload;
  } else {
    return state;
  }
};

// Selectors
export const getCompanyDetails = (state) => state.companyDetails;
